export default __webpack_public_path__ + "static/media/6.5.249d72e7.jpg";